export type Placement = 'bottom' | 'bottom-end' | 'left' | 'top' | 'right';

export function placementToCSSProperty(placement: Placement) {
  const staticSide = {
    'top': 'bottom',
    'right': 'left',
    'bottom': 'top',
    'left': 'right',
    'bottom-end': 'top',
  }[placement];

  return staticSide;
}
